import { HERO_OUTLINE } from '../../../shared/constants/heroOutline.js'

import { collectActiveFramePathIds } from './modelPreviewAdapter.js'
import { collectVisualizationPathIds } from './visPreviewAdapter.js'

function makeTierSvgId(tier) {
  const paddedTier = String(tier?.ref_tier ?? '').padStart(2, '0')
  return `${tier?.building_id ?? ''}-${paddedTier}`
}

function getOutlineId(item) {
  if (item.type === HERO_OUTLINE.BUILDINGS) return String(item.building?.id_cad ?? '')
  if (item.type === HERO_OUTLINE.TIERS)     return String(item.tier?.id_cad ?? makeTierSvgId(item.tier))
  if (item.type === HERO_OUTLINE.APARTMENTS)return String(item.product?.uuid ?? '')
  return ''
}

function compareByOutlineId(a, b) {
  return getOutlineId(a).localeCompare(getOutlineId(b), undefined, { numeric: true, sensitivity: 'base' })
}

export { getOutlineId }

function buildOutlineRawCandidates({ activeOutline, activePathIds, buildings = [], tiers = [] }) {
  if (!activePathIds || activePathIds.size === 0) return []

  if (activeOutline === HERO_OUTLINE.BUILDINGS) {
    return buildings
      .filter((building) => activePathIds.has(building.id_cad))
      .map((building) => ({ type: HERO_OUTLINE.BUILDINGS, building }))
      .sort(compareByOutlineId)
  }

  if (activeOutline === HERO_OUTLINE.TIERS) {
    const buildingById = new Map(buildings.map((b) => [b.id_cad, b]))
    return tiers
      .filter((tier) => activePathIds.has(makeTierSvgId(tier)))
      .map((tier) => ({
        type: HERO_OUTLINE.TIERS,
        tier,
        building: buildingById.get(tier.building_id) ?? null,
      }))
      .sort(compareByOutlineId)
  }

  return []
}

export function buildModelOutlineCandidates({
  containerEl,
  currentFrameIndex,
  activeOutline,
  buildings = [],
  tiers = [],
}) {
  const activePathIds = collectActiveFramePathIds(containerEl, currentFrameIndex)
  return buildOutlineRawCandidates({ activeOutline, activePathIds, buildings, tiers })
}

export function buildVisualizationOutlineCandidates({
  containerEl,
  activeOutline,
  buildings = [],
  tiers = [],
}) {
  const activePathIds = collectVisualizationPathIds(containerEl)
  return buildOutlineRawCandidates({ activeOutline, activePathIds, buildings, tiers })
}
